export const EMAIL_WARNING_MODAL_CLASS_NAME = "mmc-js-email-warning-modal";
